<template>
  <div class="all_input_ect" ref="inputWrapper">
    <span>{{ label }}</span>
    <div>
      <!-- 主输入框 -->
      <el-input class="input_e" v-model="mainInput" :placeholder="placeholder"
        @focus="showPopover = true; calculatePopoverPosition()" ref="mainInputRef" @clear="handleClear" clearable
        :disabled="showPopover">
        <!-- 触发 Popover -->
        <template #suffix>
          <div ref="popoverContent" class="popover-content" v-if="showPopover" :style="popoverStyle">
            <!-- Popover 内部的内容 -->
            <div>
              <el-input v-model="subInput1" placeholder="请输入第一个值" @input="updateMainInput"
                style="width:80px;"></el-input>
              <span>-</span>
              <el-input v-model="subInput2" placeholder="请输入第二个值" @input="updateMainInput"
                style="width:80px;"></el-input>
              <!-- 单位选择下拉框 -->
              <el-select v-if="showUnitSelect" v-model="unit" placeholder="请选择单位"
                style="width: 80px; margin-left: 10px;" @change="onUnitChange">
                <el-option label="KB" value="KB"></el-option>
                <el-option label="MB" value="MB"></el-option>
              </el-select>
              <el-button type="primary" size="small" @click="closePopover" style="margin-left: 10px;" class="btn_e">
                确认
              </el-button>
            </div>
          </div>
        </template>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompressSizeInput',
  props: {
    label: {
      type: String,
      default: '压缩包大小'
    },
    placeholder: {
      type: String,
      default: '点击输入内容'
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mainInput: this.value, // 主输入框绑定值
      subInput1: '', // 第一个子输入框值
      subInput2: '', // 第二个子输入框值
      unit: 'KB', // 默认单位
      showPopover: false, // 控制 popover 显示状态
      popoverStyle: {}, // 弹出框样式
    };
  },
  watch: {
    value(newVal) {
      this.mainInput = newVal;
    },
    mainInput(newVal) {
      this.$emit('input', newVal); // 双向绑定父组件值
    }
  },
  computed: {
    showUnitSelect() {
      const noUnitLabels = ['贴图数量', '物体数量', '素材面数', '顶点数', '下载数量', '查看数量','收藏数量','收入金额']; // 定义不需要单位的 label 列表
      const shouldShowUnitSelect = !noUnitLabels.includes(this.label); // 如果 label 不在列表中，则显示单位选择框

      if (!shouldShowUnitSelect) {
        this.unit = ''; // 当 label 在 noUnitLabels 列表中时，将 unit 设为空字符串
      } else {
        this.unit = 'KB'; // 或者你可以根据需要设定默认单位
      }

      return shouldShowUnitSelect;
    }
  },
  methods: {
    onUnitChange(newUnit) {
      this.unit = newUnit;

      this.updateMainInput(); // 确保在单位更改后立即更新mainInput
    },
    handleClear() {
      console.log('Clearing inputs in child component');
      this.subInput1 = ''; // 清空第一个输入框
      this.subInput2 = ''; // 清空第二个输入框
      this.unit = 'KB';      // 清空单位选择
      this.mainInput = ''; // 清空主输入框

      // Emit the 'input' event to update the parent component
      this.$emit('input', '');

      // Force re-render the component to ensure DOM updates
      this.$forceUpdate();

      // Use $nextTick to ensure the DOM is updated before logging
      this.$nextTick(() => {
        console.log('After clearing:', this.subInput1, this.subInput2);
      });
    },
    updateMainInput() {

      this.subInput1 = this.validateNumber(this.subInput1);
      this.subInput2 = this.validateNumber(this.subInput2);

      if (this.subInput1 && this.subInput2) {
        const num1 = parseFloat(this.subInput1);
        const num2 = parseFloat(this.subInput2);

        if (!isNaN(num1) && !isNaN(num2)) {
          if (num1 > num2) {
            this.mainInput = `${this.subInput1} > ${this.subInput2}`;
          } else if (num1 < num2) {
            this.mainInput = `${this.subInput1} < ${this.subInput2}`;
          } else {
            this.mainInput = `${this.subInput1} = ${this.subInput2}`;
          }
        } else {
          this.mainInput = `${this.subInput1 || ''} - ${this.subInput2 || ''}`;
        }
      } else {
        this.mainInput = `${this.subInput1 || ''} - ${this.subInput2 || ''}`;
      }

      if (this.showUnitSelect) {
        this.mainInput += ` ${this.unit}`;
      }


      if (this.subInput1 || this.subInput2) {

        this.$emit('input', this.mainInput);
      } else {
        this.mainInput = '';
      }
    },
    validateNumber(value) {
      // 使用正则表达式匹配数字（包括小数）
      if (value === '' || /^\d*\.?\d*$/.test(value)) {
        return value;
      } else {
        return value.replace(/[^0-9.]/g, ''); // 移除非数字字符
      }
    },
    closePopover() {
      this.showPopover = false;
      this.$emit('input', this.mainInput);
      this.$emit('update', this.mainInput);
    },

    calculatePopoverPosition() {
      const inputRect = this.$refs.inputWrapper.getBoundingClientRect();
      const parentRect = this.$refs.inputWrapper.parentElement.getBoundingClientRect();

      const popoverWidth = 250; // 弹出框宽度
      const popoverHeight = 80; // 弹出框高度

      this.popoverStyle = {
        position: 'absolute',
        top: `${inputRect.bottom - parentRect.top}px`, // 相对于父容器的 top
        left: `${inputRect.left - parentRect.left - 200}px`, // 相对于父容器的 left
        width: `${popoverWidth}px`,
        height: `${popoverHeight}px`,
        zIndex: 1000,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        padding: '10px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '4px'
      };
    },

    handleDocumentClick(event) {
      // 检查点击的目标是否在 popover 或主输入框之外
      const popoverContent = this.$refs.popoverContent;
      const mainInputRef = this.$refs.mainInputRef ? this.$refs.mainInputRef.$el : null;

      if (!popoverContent || !mainInputRef) {
        console.warn('Popover content or main input reference is not available.');
        return;
      }

      if (
        this.showPopover &&
        event.target !== popoverContent &&
        !popoverContent.contains(event.target) &&
        event.target !== mainInputRef &&
        !mainInputRef.contains(event.target)
      ) {
        this.closePopover();
      }
    }
  },
  mounted() {
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleDocumentClick);
  }
};
</script>

<style scoped>
.popover-content {
  display: flex;
  align-items: center;
  width: 220px;
  z-index: 9999999 !important;
}

.all_input_ect {
  margin-top: 10px;
  margin-left: 15px;
  display: flex;
  align-items: center;
  span{
    width: 60px;
    margin-right: 5px;
    text-align: end;
  }
}

.input_e {
  width: 160px;
  height: 40px;
  border: 1px solid #858585 !important;
  border-radius: 5px;
  position: relative;
  font-size: 12px;
}

/deep/.el-input__icon {
  line-height: 30px !important;
}

.popover-content {
  width: 370px !important;
  padding: 0px 5px !important;
}

/deep/.btn_e span{
  color:#e8f3ff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CompressSizeInput.vue